/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import AppointmentAction from 'DesignSystem/AppointmentAction/index'
import React from 'react'
import SeatAction from 'DesignSystem/SeatAction/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/AppointmentActions/Seat/Content"
  
}) {
let appointmentActionsAppointmentBookingIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_actions',
path: 'appointment_booking.id',
})
  return (<React.Fragment
>
<SeatAction
  viewPath={`${viewPath}/SeatAction`}
 data="appointment_actions.appointment_booking.id"
 id={appointmentActionsAppointmentBookingIdValueData}
>
{childProps => (
<AppointmentAction
{...childProps}
  viewPath={`${viewPath}/AppointmentAction`}
 text="Seat"
/>
)}
</SeatAction>
{children}
</React.Fragment>)
}